module.exports = __webpack_public_path__ + "static/media/4start.1ae305b0.png";